import { createContext } from 'react';

import { FormInstance } from 'antd';

import { ActividadesComercio } from '../../../../../../../../../shared/interfaces';
import { StepTwoCommerceForm } from '../../../../interfaces/steps-forms.interface';

interface StepTwoFormContextProps {
  stepTwoForm:                FormInstance<StepTwoCommerceForm> | undefined;
  rubricSelected:             ActividadesComercio | undefined
  setRubricSelected:          React.Dispatch<React.SetStateAction<ActividadesComercio | undefined>>
}

export const StepTwoFormContext = createContext({} as StepTwoFormContextProps);
